<template>
  <div>
    <b-card>
      <b-row class="justify-content-between mb-[24px]">
        <b-col
          cols="auto"
          class="flex items-center"
        >
          <b-button
            variant="primary"
            size="sm"
            class="rounded-lg mr-2 "
            @click="$router.go(-1)"
          >
            <b-icon-chevron-left scale="1.3" />
          </b-button>
          <div>
            <h4>
              <strong class="text-black text-2xl">Data Pelanggan Komchat AI</strong>
            </h4>
          </div>
        </b-col>
      </b-row>
      <div>
        <b-dropdown
          id="dropdown-filter-main"
          class="filter"
          no-caret
          variant="outline-primary"
          toggle-class="text-decoration-none toggle-custom rounded-lg !py-[5px] !px-[10px]"
          no-close-on-click
        >
          <template #button-content>
            <div class="flex items-center gap-2">
              <span>Filter</span>
              <b-img
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/filter-search.svg"
                height="20"
                alt="filter-search"
              />
            </div>
          </template>

          <b-dropdown
            v-for="(option, index) in filter"
            :id="`dropdown-filter-${index}`"
            :key="index"
            class="w-100"
            toggle-class="text-left"
            variant="none"
            left
            no-caret
            dropright
            menu-class="filter-sub-menu p-0 rounded shadow"
          >
            <template #button-content>
              <div class="flex w-100 justify-between">
                <span class="hover-salmon text-6">{{ option.label }}</span>
                <b-icon
                  icon="chevron-right"
                  class="cursor-pointer"
                />
              </div>
            </template>
            <div class="filter-sub-content p-2 bg-white rounded min-w-[300px]">
              <!-- Search: Produk, Lokasi -->
              <div
                v-if="option.key === 'product' || option.key === 'address'"
                class="mb-2"
              >
                <BInputGroup class="input-group-merge">
                  <BInputGroupPrepend is-text>
                    <feather-icon icon="SearchIcon" />
                  </BInputGroupPrepend>
                  <BFormInput
                    v-model="searchFilterByKey[option.key]"
                    :placeholder="option.key === 'product' ? 'Cari produk' : 'Cari lokasi'"
                    size="md"
                    style="padding: 8px 1rem 8px 0px"
                  />
                </BInputGroup>
              </div>
              <!-- Checkbox list: Produk, Lokasi, Status Order, Metode Pembayaran -->
              <div
                v-if="option.options && option.options.length > 0"
                class="overflow-y-auto max-h-[220px] mb-2"
              >
                <b-form-checkbox
                  v-for="(optionFilter, indexFilter) in getFilteredOptions(option)"
                  :key="indexFilter"
                  v-model="selectedFilter[option.key]"
                  :name="`checkbox-${option.key}-${indexFilter}`"
                  :value="optionFilter.id"
                  class="filter-sub-checkbox d-block mb-1 text-dark custom-control-primary"
                >
                  {{ optionFilter.name }}
                </b-form-checkbox>
                <div
                  v-if="getFilteredOptions(option).length === 0"
                  class="text-muted small py-2"
                >
                  Tidak ada data
                </div>
              </div>
              <!-- Total Order: Min / Max -->
              <div
                v-else-if="option.key === 'total_order'"
                class="mb-2"
              >
                <div class="d-flex align-items-end gap-2">
                  <div class="flex-grow-1">
                    <label class="small text-muted d-block mb-1">Min</label>
                    <b-form-input
                      v-model="orderMinInput"
                      placeholder="Minimum order"
                      type="number"
                      min="0"
                      class="rounded"
                      @keypress="isNumber($event)"
                    />
                  </div>
                  <span class="small text-muted pb-2">-</span>
                  <div class="flex-grow-1">
                    <label class="small text-muted d-block mb-1">Max</label>
                    <b-form-input
                      v-model="orderMaxInput"
                      placeholder="Maximal order"
                      type="number"
                      min="0"
                      class="rounded"
                      @keypress="isNumber($event)"
                    />
                  </div>
                </div>
              </div>
              <!-- Total Belanja: Rp Min / Rp Max -->
              <div
                v-else-if="option.key === 'total_belanja'"
                class="mb-2"
              >
                <b-input-group
                  prepend="Rp"
                  class="mb-2"
                >
                  <b-form-input
                    v-model="orderAmountMinInput"
                    placeholder="Harga minimum"
                    @keypress="isNumber($event)"
                  />
                </b-input-group>
                <b-input-group
                  prepend="Rp"
                >
                  <b-form-input
                    v-model="orderAmountMaxInput"
                    placeholder="Harga maksimum"
                    @keypress="isNumber($event)"
                  />
                </b-input-group>
              </div>
              <!-- Tanggal: Date Range Picker -->
              <div
                v-else-if="option.key === 'tanggal'"
                class="mb-2"
              >
                <date-range-picker
                  ref="datePicker"
                  v-model="dateRange"
                  :locale-data="locale"
                  :ranges="ranges"
                  opens="right"
                  class="w-100 rounded"
                >
                  <template #input>
                    <span class="small">
                      {{ dateRange.startDate && dateRange.endDate
                        ? `${SLASH_DATE(dateRange.startDate)} - ${SLASH_DATE(dateRange.endDate)}`
                        : 'Pilih Tanggal' }}
                    </span>
                  </template>
                </date-range-picker>
              </div>
              <!-- Footer: Reset + Terapkan -->
              <div class="grid grid-cols-9 gap-1 border-t w-full bg-white rounded-b pt-2">
                <div class="col-span-3">
                  <b-button
                    size="sm"
                    variant="outline-danger"
                    class="rounded w-full !px-[2px]"
                    @click="resetOneFilter(option.key)"
                  >
                    Reset
                  </b-button>
                </div>
                <div class="col-span-6">
                  <b-button
                    size="sm"
                    variant="primary"
                    class="rounded w-full"
                    @click="applyOneFilter()"
                  >
                    Terapkan
                  </b-button>
                </div>
              </div>
            </div>
          </b-dropdown>
          <div class="px-1 mt-1">
            <b-button
              size="sm"
              variant="outline-primary"
              class="rounded-lg w-full"
              @click="resetFilter()"
            >
              Reset Filter
            </b-button>
          </div>
        </b-dropdown>
      </div>
      <BOverlay
        id="infinite-list"
        :show="isLoading"
        spinner-variant="primary"
        variant="light"
        blur="0"
        opacity="0.5"
        rounded="sm"
      >
        <!-- <div style="height: calc(100vh - 330px); overflow-y: scroll;"> -->
        <BTable
          id="table-komchat-ai"
          :items="items"
          :fields="fields"
          show-empty
          empty-text="Tidak ada data yang ditampilkan."
          responsive
          sticky-header="400px"
          class="mt-1"
          @scroll.native="handleScroll"
        >

          <template #cell(phone)="data">
            <div class="min-w-[140px] text-[#222]">
              <span class="flex items-center">
                <img
                  src="https://storage.googleapis.com/komerce/assets/icons/whatsapp.svg"
                  alt="icon whatsapp"
                >
                <span class="ml-[12px]">{{ data.item.phone }}</span>
              </span>
            </div>
          </template>

        </BTable>
        <!-- </div> -->
        <BRow>
          <BCol
            cols="12"
            class="d-flex justify-content-between"
          >
            <div class="d-flex justify-content-center align-items-center gap-[16px]">
              <strong class="text-[#333]"> Total Data Pelanggan </strong>
              <strong class="text-[#F95031]">{{ count || 0 }}</strong>
            </div>

            <b-button
              variant="primary"
              class="rounded-lg w-[150px]"
              :disabled="isImporting || !count"
              @click="sendDataImport"
            >
              <b-spinner
                v-if="isImporting"
                small
                class="mr-1"
              />
              {{ isImporting ? 'Memproses...' : 'Buat' }}
            </b-button>
          </BCol>
        </BRow>
      </BOverlay>
    </b-card>
  </div>
</template>
<script>
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import {
  today,
  last2,
  last7,
  last30,
  firstDateOfMonth,
  lastMonth,
  lastDateOfLastMonth,
  datePickerLocale,
  datePickerRanges,
} from '@/store/helpers'
import { isNumber } from '@/libs/helpers'
import { SLASH_DATE, START_FULL_DATE, END_FULL_DATE } from '@/libs/formatDate'
import { apiGetContactOrderList, apiGetContactOrderFilter, apiImportContactFromKomship } from './service/api.list-contact.service'
import { fields } from './config'

export default {
  components: { DateRangePicker },
  data() {
    return {
      fields,
      isLoading: false,
      items: [],
      count: 0,
      filter: [], // array of { label, key, options: [{ id, name }] } dari BE
      // Payload GET /contact/order/list (sesuai api.list-contact.service.js)
      listPayload: {
        product: null, // IDs produk, e.g. "1,2,3"
        address: null, // Alamat, e.g. "banjar,bogor"
        order_min: null, // Min total order
        order_max: null, // Max total order
        order_amount_min: null, // Min nominal order
        order_amount_max: null, // Max nominal order
        order_date_min: null, // Min tanggal order (date-time)
        order_date_max: null, // Max tanggal order (date-time)
        payment_method: null, // e.g. "COD,BANK_TRANSFER"
        status_order: null, // e.g. "review,reject"
        type: 'komchat_ai',
        limit: 10,
        offset: 0,
      },
      // Payload GET /contact/order/filter
      filterPayload: {
        type: 'komchat_ai',
      },
      isLastData: false,
      isImporting: false,
      openFilterDropdownId: null,
      selectedFilter: {
        product: [],
        address: [],
        status_order: [],
        payment_method: [],
        total_order: [],
      },
      // Search per kategori (Produk, Lokasi)
      searchFilterByKey: {
        product: '',
        address: '',
      },
      // Manual filter: Total Order
      orderMinInput: '',
      orderMaxInput: '',
      // Manual filter: Total Belanja (Rp)
      orderAmountMinInput: '',
      orderAmountMaxInput: '',
      // Manual filter: Tanggal
      dateRange: { startDate: null, endDate: null },
      locale: datePickerLocale,
      ranges: datePickerRanges,
      isNumber,
    }
  },
  mounted() {
    this.getListContact()
    this.getFilterContact()
    this.$root.$on('bv::dropdown::show', bvEvent => {
      const id = bvEvent.componentId
      if (id && id.startsWith('dropdown-filter-') && id !== 'dropdown-filter-main') {
        this.openFilterDropdownId = id
      }
    })
    this.$root.$on('bv::dropdown::hide', bvEvent => {
      const id = bvEvent.componentId
      if (id && id.startsWith('dropdown-filter-') && id !== 'dropdown-filter-main') {
        this.openFilterDropdownId = null
      }
      if (id === 'dropdown-filter-main' && this.openFilterDropdownId) {
        bvEvent.preventDefault()
      }
    })
  },
  beforeDestroy() {
    this.$root.$off('bv::dropdown::show')
    this.$root.$off('bv::dropdown::hide')
  },
  methods: {
    SLASH_DATE,
    async getListContact() {
      if (this.isLastData || this.isLoading) return
      try {
        this.isLoading = true
        const res = await apiGetContactOrderList(this.listPayload)
        const { data } = res.data
        const listContact = data?.data ?? []
        const isLoadMore = this.listPayload.offset > 0

        if (isLoadMore) {
          this.items.push(...listContact)
        } else {
          this.items = listContact
        }

        this.count = data?.count ?? this.items.length
        this.isLastData = listContact.length < this.listPayload.limit
        this.listPayload.offset = this.items.length
      } catch (error) {
        this.$toast_error({ message: 'Gagal mengambil data' })
      } finally {
        this.isLoading = false
      }
    },
    mapFilterFromBE(data) {
      if (!data || typeof data !== 'object') return []
      const STATUS_ORDER_LABELS = { review: 'On Review', accept: 'Diterima', reject: 'Ditolak' }
      const PAYMENT_LABELS = {
        COD: 'COD',
        BANK_TRANSFER: 'Bank Transfer',
        QRIS: 'QRIS',
        VIRTUAL_ACCOUNT: 'Virtual Account',
      }
      const result = []
      if (Array.isArray(data.product)) {
        result.push({
          label: 'Produk',
          key: 'product',
          options: data.product.map(item => ({
            id: item.id,
            name: `${item.name} (${item.total})`,
          })),
        })
      }
      if (Array.isArray(data.address)) {
        result.push({
          label: 'Lokasi',
          key: 'address',
          options: data.address.map(item => ({
            id: item.id,
            name: `${item.name} (${item.total})`,
          })),
        })
      }
      if (Array.isArray(data.status_order)) {
        result.push({
          label: 'Status Order',
          key: 'status_order',
          options: data.status_order.map(value => ({
            id: value,
            name: STATUS_ORDER_LABELS[value] || value,
          })),
        })
      }
      if (Array.isArray(data.payment_method)) {
        result.push({
          label: 'Metode Pembayaran',
          key: 'payment_method',
          options: data.payment_method.map(value => ({
            id: value,
            name: PAYMENT_LABELS[value] || value,
          })),
        })
      }
      if (data.total_order && Array.isArray(data.total_order)) {
        result.push({
          label: 'Total Order',
          key: 'total_order',
          options: data.total_order.map(item => ({
            id: item?.id ?? item?.min ?? item,
            name: typeof item === 'object' && item?.min != null
              ? `${item.min} - ${item.max}`
              : String(item),
          })),
        })
      }
      return result
    },
    async getFilterContact() {
      try {
        this.isLoading = true
        const res = await apiGetContactOrderFilter(this.filterPayload)
        const raw = res.data?.data ?? res.data
        const apiFilters = this.mapFilterFromBE(raw) ?? []
        const manualFilters = [
          { label: 'Total Order', key: 'total_order', type: 'manual' },
          { label: 'Total Belanja', key: 'total_belanja', type: 'manual' },
          { label: 'Tanggal', key: 'tanggal', type: 'manual' },
        ]
        this.filter = [...apiFilters, ...manualFilters]
      } catch (error) {
        this.$toast_error({ message: 'Gagal mengambil data' })
      } finally {
        this.isLoading = false
      }
    },
    handleScroll(event) {
      if (this.isLastData || this.isLoading) return
      const { scrollTop, scrollHeight, clientHeight } = event.target
      if (scrollTop + clientHeight >= scrollHeight - 1) {
        this.getListContact()
      }
    },
    getFilteredOptions(option) {
      if (!option?.options?.length || option?.type === 'manual') return []
      const q = this.searchFilterByKey[option.key]
      if (!q || typeof q !== 'string') return option.options
      const lower = q.trim().toLowerCase()
      if (!lower) return option.options
      return option.options.filter(opt => (opt.name && String(opt.name).toLowerCase().includes(lower)))
    },
    resetOneFilter(key) {
      if (this.selectedFilter[key]) {
        this.selectedFilter[key] = []
      }
      if (this.searchFilterByKey[key] !== undefined) {
        this.searchFilterByKey[key] = ''
      }
      if (key === 'total_order') {
        this.orderMinInput = ''
        this.orderMaxInput = ''
      }
      if (key === 'total_belanja') {
        this.orderAmountMinInput = ''
        this.orderAmountMaxInput = ''
      }
      if (key === 'tanggal') {
        this.dateRange = { startDate: null, endDate: null }
      }
      this.handleFilter()
    },
    applyOneFilter() {
      this.handleFilter()
    },
    applySelectedToPayload() {
      const toParam = arr => (arr?.length && Array.isArray(arr) ? arr.join(',') : null)
      this.listPayload.product = toParam(this.selectedFilter.product)
      this.listPayload.address = toParam(this.selectedFilter.address)
      this.listPayload.status_order = toParam(this.selectedFilter.status_order)
      this.listPayload.payment_method = toParam(this.selectedFilter.payment_method)
      // Manual filter: Total Order
      this.listPayload.order_min = this.orderMinInput ? Number(this.orderMinInput) : null
      this.listPayload.order_max = this.orderMaxInput ? Number(this.orderMaxInput) : null
      // Manual filter: Total Belanja (strip non-digit)
      const amountMin = this.orderAmountMinInput ? String(this.orderAmountMinInput).replace(/\D/g, '') : ''
      const amountMax = this.orderAmountMaxInput ? String(this.orderAmountMaxInput).replace(/\D/g, '') : ''
      this.listPayload.order_amount_min = amountMin ? Number(amountMin) : null
      this.listPayload.order_amount_max = amountMax ? Number(amountMax) : null
      // Manual filter: Tanggal
      this.listPayload.order_date_min = this.dateRange?.startDate
        ? START_FULL_DATE(this.dateRange.startDate) : null
      this.listPayload.order_date_max = this.dateRange?.endDate
        ? END_FULL_DATE(this.dateRange.endDate) : null
    },
    handleFilter() {
      this.applySelectedToPayload()
      this.listPayload.offset = 0
      this.isLastData = false
      this.items = []
      this.getListContact()
    },
    resetFilter() {
      this.selectedFilter = {
        product: [],
        address: [],
        status_order: [],
        payment_method: [],
        total_order: [],
      }
      this.searchFilterByKey = { product: '', address: '' }
      this.orderMinInput = ''
      this.orderMaxInput = ''
      this.orderAmountMinInput = ''
      this.orderAmountMaxInput = ''
      this.dateRange = { startDate: null, endDate: null }
      this.listPayload.product = null
      this.listPayload.address = null
      this.listPayload.status_order = null
      this.listPayload.payment_method = null
      this.listPayload.order_min = null
      this.listPayload.order_max = null
      this.listPayload.order_amount_min = null
      this.listPayload.order_amount_max = null
      this.listPayload.order_date_min = null
      this.listPayload.order_date_max = null
      this.listPayload.offset = 0
      this.isLastData = false
      this.items = []
      this.getListContact()
    },
    async sendDataImport() {
      if (this.isImporting || !this.count) return
      this.applySelectedToPayload()
      const filterContact = {
        product: this.listPayload.product,
        address: this.listPayload.address,
        order_min: this.listPayload.order_min,
        order_max: this.listPayload.order_max,
        order_amount_min: this.listPayload.order_amount_min,
        order_amount_max: this.listPayload.order_amount_max,
        order_date_min: this.listPayload.order_date_min
          ? moment(this.listPayload.order_date_min).format('YYYY-MM-DD') : null,
        order_date_max: this.listPayload.order_date_max
          ? moment(this.listPayload.order_date_max).format('YYYY-MM-DD') : null,
        payment_method: this.listPayload.payment_method,
        total_contact: this.count,
        status_order: this.listPayload.status_order,
        type: 'komchat_ai',
      }
      const payload = Object.fromEntries(
        Object.entries(filterContact).filter(
          ([_, value]) => value !== null && value !== undefined && value !== ''
            && !(Array.isArray(value) && value.length === 0),
        ),
      )
      try {
        this.isImporting = true
        await apiImportContactFromKomship(payload)
        this.$toast_success({ message: 'Data berhasil ditambahkan!' })
        this.$router.push({ name: 'grup-contact', params: { onImport: true, total: this.count } })
      } catch (err) {
        this.$toast_error({ message: err?.response?.data?.message || 'Data gagal ditambahkan' })
      } finally {
        this.isImporting = false
      }
    },
  },
}
</script>

<style scoped>
.filter-sub-menu {
  min-width: 280px;
  max-width: 320px;
  max-height: 85vh;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid #dee2e6;
}
.filter-sub-dropdown {
  border-radius: 0.375rem;
}
.filter-sub-list {
  max-height: 220px;
  min-height: 80px;
  overflow-y: auto;
  overflow-x: hidden;
}
.filter-sub-checkbox {
  font-size: 0.875rem;
}
.filter-sub-checkbox.custom-control-input:checked ~ .custom-control-label::before {
  border-color: #f95031;
  background-color: #f95031;
}
</style>
